"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reportContent = require("@/utils/reportContent");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * 【操作埋点】2026-05-25 掉单规则 content 格式化
 */
var _default = exports.default = {
  name: 'pricing',
  data: function data() {
    return {
      form: {},
      id: this.$route.params.id || '',
      type: this.$route.query.type || 1
    };
  },
  mounted: function mounted() {
    this.getInfo();
  },
  methods: {
    /**
     * 获取info
     */
    getInfo: function getInfo() {
      var _this = this;
      var url = 'agentapi/business/store_order_hidding',
        params = {};
      if (this.type == 2) {
        url = 'agentapi/business/agent_order_hidding';
        params.son_id = this.id;
      } else {
        params.store_id = this.id;
      }
      this.$get(url, params).then(function (res) {
        if (res.new_steal_switch == undefined) {
          res = {
            user_forbidden_finish: 0,
            steal_switch: 0,
            plan: [{
              begin: '00:00',
              end: '00:01'
            }],
            short_minute: 0,
            short_rate: 0,
            short_cycle_orders: 0,
            missed_rate: 0,
            missed_min_money: 0,
            show_fail_rate: 0,
            show_fail_min_money: 0,
            missed_cycle_orders: 0,
            missed_nologin_rate: 0,
            missed_nologin_min_money: 0,
            missed_nologin_hours: 0,
            missed_nologin_cycle_orders: 0,
            new_steal_switch: 0
          };
        }
        _this.form = res;
      });
    },
    /**
     * 提交会员卡信息
     */
    postCard: function postCard() {
      var _this2 = this;
      var url = 'agentapi/business/store_order_hidding',
        params = JSON.parse(JSON.stringify(this.form));
      if (this.type == 2) {
        url = 'agentapi/business/agent_order_hidding';
        params.son_id = this.id;
      } else {
        params.store_id = this.id;
      }
      // 【操作埋点】2026-05-25 pc_shop_steal_1 设置掉单规则（上报各概率与开关字段）
      this.$post(url, params, {
        operation_option: '设置掉单规则',
        content: (0, _reportContent.buildReportContent)(params, _reportContent.STEAL_RULE_LABELS, {
          prefix: this.type == 2 ? "\u4EE3\u7406\u5546ID ".concat(this.id) : "\u5546\u6237ID ".concat(this.id),
          formatters: {
            new_steal_switch: _reportContent.formatYesNo
          }
        }),
        operation_id: 'pc_shop_steal_1'
      }).then(function (res) {
        _this2.$message({
          message: '提交成功',
          type: 'success'
        });
      });
    }
  }
};